import React, { Component } from 'react'
import data from './data'
import SpecialtyContainer from './SpecialtyContainer'

export default class SpecialtyMoreInfo extends Component {
  render() {
    return (
      <div>
        {/* <h4>Placeholder For Specialty Info</h4> */}
      </div>
    )
  }
}

// export default function SpecialtyMoreInfo() {

//   const docs = data.map((data, index) => {
//     render(){
//       return (
//         <SpecialtyMoreInfo
//           key={index}
//           //or key={country.id} if data has ids
//           name={data.name}
//           definition={data.description}
//         />
//       )
//     }
// }


// import React, {Component} from 'react'

// export default class SpecialtyMoreInfo = { (docs) } => {
//   render() {
//     return (
//     <>
//       {
//         data.length > 0 &&
  
//           (data.map((data, index) => {
      
//             return (
//               <>
//                 <div key={index} className="specialty-card">

//                   <h4 className="name">Name: {data.name}</h4>
            
//                   <h5>Description: {data.description}</h5>
//                 </div>
//               </>
//             )
//           })
//           )
//         }
//       </>
//     )
//   }
// }
